import React from 'react';

import { Button, Form, Modal } from 'antd';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { SimHistoryInfo } from 'domain/entities/SimulateEntity';
import { DialogIcon } from 'presentation/components/Modal/DialogIcon';
import { ConfirmModalProps } from 'presentation/components/Modal/Modal.type';
import { FormRadio } from 'presentation/components/form/FormRadio.component';

interface props extends ConfirmModalProps {
    data?: SimHistoryInfo[];
}

export const SimHistoryModal = ({
    open,
    type = 'info',
    icon,
    okText = '次へ',
    cancelText = '戻る',
    onCancel,
    onOk,
    returnValue,
    okButtonProps,
    cancelButtonProps,
    data,
}: props) => {
    const [form] = Form.useForm();
    const [options, setOptions] = React.useState<OptionEntity[]>([]);
    const [btnDisabled, setBtnDisabled] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (data && data.length > 0) {
            const options: OptionEntity[] = data.map((item: SimHistoryInfo, index: number) => {
                return {
                    label: index + 1 + ' ' + item.simulationTitle,
                    value: item.id,
                };
            });
            setOptions(options);
        }
    }, [data]);

    React.useEffect(() => {
        if (open) {
            form.resetFields();
            setBtnDisabled(true);
        }
    }, [open]);

    const handleOk = () => {
        const selectedValue = form.getFieldValue('simId');
        if (selectedValue) {
            onOk && onOk(selectedValue);
            return;
        }
    };

    const valueChange = () => {
        form.validateFields({ validateOnly: true })
            .then(() => {
                setBtnDisabled(false);
            })
            .catch((err) => {
                setBtnDisabled(err.errorFields.length > 0);
            });
    };

    const handleCancel = () => {
        if (returnValue) {
            onCancel && onCancel(returnValue);
            return;
        }
        onCancel && onCancel();
    };

    return (
        <Modal
            width={327}
            open={open}
            footer={null}
            centered
            className="modal-info sim-history-container"
        >
            <Form form={form} onValuesChange={valueChange}>
                <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                    <div style={{ width: '100%' }} className="center-inside">
                        <DialogIcon type={type} icon={icon} />
                    </div>
                    <div
                        className="confirm-modal-2-title text-sm"
                        style={{ marginBottom: 8, marginTop: 32 }}
                    >
                        <div>履歴の保存は10件までです</div>
                        <div>上書きするデータを選択してください。</div>
                    </div>
                    <div
                        className="confirm-modal-2-description"
                        style={{ marginBottom: 24, color: '' }}
                    >
                        <FormRadio options={options} name="simId" required requiredMessage=" " />
                    </div>
                    <Button
                        type="primary"
                        className="button-login-text"
                        {...okButtonProps}
                        disabled={btnDisabled}
                        style={{
                            width: '100%',
                            height: 48,
                            marginBottom: 12,
                            ...okButtonProps?.style,
                        }}
                        onClick={() => handleOk()}
                    >
                        {okText}
                    </Button>
                    <Button
                        type="link"
                        block
                        className="text-button-cancel"
                        style={{ width: '100%', height: 48 }}
                        onClick={() => handleCancel()}
                        {...cancelButtonProps}
                    >
                        {cancelText}
                    </Button>
                </section>
            </Form>
        </Modal>
    );
};
